import { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import api from '../services/api';

const useAnalytics = (firmId: number | string | undefined, productId: number | string | null = null) => {
    const [visitId, setVisitId] = useState<number | null>(null);
    const visitStarted = useRef(false);

    // Get or create visitor ID from localStorage
    const getVisitorId = (): string => {
        let vid = localStorage.getItem('store_visitor_id');
        if (!vid) {
            vid = uuidv4();
            localStorage.setItem('store_visitor_id', vid);
        }
        return vid;
    };

    useEffect(() => {
        if (!firmId || visitStarted.current) return;

        const startVisit = async () => {
            try {
                visitStarted.current = true;
                const visitorId = getVisitorId();
                const landingPage = window.location.pathname;

                const response = await api.post('/public/analytics/visit', {
                    firm_id: firmId,
                    product_id: productId,
                    visitor_id: visitorId,
                    landing_page: landingPage
                });

                const data = response.data || response;
                if (data.success || data.visit_id) {
                    setVisitId(data.visit_id);
                }
            } catch (error) {
                console.error('Analytics error:', error);
            }
        };

        startVisit();
    }, [firmId, productId]);

    // Function to log custom events
    const logEvent = async (eventType: string, metadata: Record<string, any> = {}) => {
        if (!visitId) return;

        try {
            await api.post('/public/analytics/event', {
                visit_id: visitId,
                event_type: eventType,
                metadata: metadata
            });
        } catch (error) {
            console.error('Event log error:', error);
        }
    };

    return { logEvent, visitId };
};

export default useAnalytics;
